export default class StatisticsFormatter {
  constructor(fileName, stats, packing = 12) {
    this.fileName = fileName;
    this.stats = stats;
    this.packing = packing;
    this.statString = '';
  }

  toText(packing = 9) {
    this.statString += this.templateHead();
    if (this.hasElementTypes()) {
      this.statString += this.templateElementTypes();
    } else {
      this.statString += this.templatePlainElements();
    }
    this.statString += "\n";
    this.statString += this.templateSpecialCharacters();
    this.statString += "\n";
    this.statString += this.templateImages();
    return this.statString;
  }

  countList(els, type = 'name') {
    return els.map(e => {
      return this.packedCount(e, type);
    }).join("\n");
  }

  hasElementTypes() {
    return this.stats.elements.length > 0 && this.stats.elements[0].type;
  }

  packedCount(node, type = 'name') {
    return this.packString(node[type]) + node.count;
  }

  packString(str) {
    return (str + (' '.repeat(this.packing))).slice(0,this.packing);
  }

  templateHead() {
    return (
`Statistics for ${this.fileName}

Character Count: ${this.stats.character_count}
Word Count: ${this.stats.word_count}

`
    );
  }

  templateElementTypes() {
    return (
`Paragraph Styles:
${this.countList(this.stats.elements.filter(e => e.type == 'para'))}

Character Styles:
${this.countList(this.stats.elements.filter(e => e.type == 'char'))}

Other Styles:
${this.countList(this.stats.elements.filter(e => e.type == 'other'))}
`
    );
  }

  templatePlainElements() {
    return (
`Styles:
${this.countList(this.stats.elements)}
`
    );
  }

  templateSpecialCharacters() {
    return (
`Special Characters:
${this.countList(this.stats.special_characters, 'character')}
`
    );
  }

  templateImages() {
    return (
`Images:
${this.stats.images.map(i => i.name || i.file_name).join("\n")}
`
    );
  }
}
